import type { ModelIconProps } from "./model-icon.type";

import {
  CarryOutOutlined,
  EnvironmentOutlined,
  FieldTimeOutlined,
  FileSearchOutlined,
  FormOutlined,
  GlobalOutlined,
  MessageOutlined,
  ProjectOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import classNames from "classnames";
import { RiBuildingLine } from "react-icons/ri";

import { IconCustom } from "@/ui/icon-custom";

const ModelIcon = ({ model, style, className }: ModelIconProps) => {
  const props = { style, className };

  switch (model) {
    case "activity":
      return <FieldTimeOutlined {...props} />;
    case "asset":
    case "assettype":
      return (
        <span className={classNames("anticon", className)}>
          <RiBuildingLine style={style} role="img" aria-label="building" />
        </span>
      );
    case "comment":
      return <MessageOutlined {...props} />;
    case "dataset":
      return null;
    case "intervention":
      return <CarryOutOutlined {...props} />;
    case "interventiontemplate":
      return <FormOutlined {...props} />;
    case "jobmodule":
      return null;
    case "location":
      return <EnvironmentOutlined {...props} />;
    case "observation":
      return <FileSearchOutlined />;
    case "organization":
      return <GlobalOutlined {...props} />;
    case "project":
      return <ProjectOutlined {...props} />;
    case "sector":
      return <IconCustom type="sector" {...props} />;
    case "technicalform":
      return <CarryOutOutlined {...props} />;
    case "user":
      return <TeamOutlined {...props} />;
    default:
      return null;
  }
};

export default ModelIcon;
